import styled, { css } from 'styled-components';
import { suppressProps } from '../../utils/index.js';
import { Text } from '../text/index.js';
const getLoadingStyles = ({ loading, theme }) => {
    if (!loading)
        return null;
    return css `
    display: inline-flex;
    align-items: center;
    ${theme.styles.pills.loading}
  `;
};
export const PillElement = styled(Text).withConfig(suppressProps('variant'))(() => css `
    display: inline-block;
    width: auto;
  `, ({ theme }) => theme.styles.pills.base, ({ theme, variant }) => theme.styles.pills.variants[variant], getLoadingStyles);
//# sourceMappingURL=pill.styles.js.map